<template>
	<figure
		v-if="hasURL || loading"
		v-skeleton="{
			loading,
			sizes: {
				Small: { width: '2rem', height: '2rem' }
			}
		}"
		class="OrganizationLogo"
	>
		<img
			:src="imageUrl"
			:alt="`Logo of ${organizationName}`"
			loading="lazy"
		/>
	</figure>
</template>


<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
	imageUrl: {
		type: String,
		required: false,
	},
	organizationName: {
		type: String,
		required: true,
	},
	loading: {
		type: Boolean,
		default: true,
	},
});

const hasURL = computed(() => !!props.imageUrl && props.imageUrl.length > 0);
</script>

<style scoped lang="scss">
	.OrganizationLogo {
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 0.25rem;
		border: 0.125rem solid $Grey-200;
		background: $White;

		@include PaddingAreas(0.25);
		@include MarginAreas(0);

		img {
			width: 2.25rem;
			height: 2.25rem;
			border-radius: 0.125rem;

			@include Breakpoint(Large, ExtraLarge) {
				width: 2.5rem;
				height: 2.5rem;
			}
		}

		i.lnr-university {
			font-size: 2.25rem;
			color: $Grey-900;
			opacity: .1;

			@include Breakpoint(Large, ExtraLarge) {
				font-size: 2.5rem;
			}
		}
	}
</style>
